module.exports = __webpack_public_path__ + "img/milan-logo-icon.654561d8.png";